module.exports = __webpack_public_path__ + "img/pin.81fad3cf.svg";